export default {
  getFrequencies: state => state.frequencies || [],
  getLeaseFrequencies: state => state.leaseFrequencies || [],
};
